import { QUEUED_AT } from "./constants";

function getQueuedAtEpoch(queuedAt) {
  switch (queuedAt) {
    case QUEUED_AT["1H"]:
      return Date.now() - 1 * 60 * 60 * 1000;

    case QUEUED_AT["2H"]:
      return Date.now() - 2 * 60 * 60 * 1000;

    case QUEUED_AT["6H"]:
    default:
      return Date.now() - 6 * 60 * 60 * 1000;

    case QUEUED_AT["12H"]:
      return Date.now() - 12 * 60 * 60 * 1000;

    case QUEUED_AT["1DAY"]:
      return Date.now() - 24 * 60 * 60 * 1000;
  }
}

function getCallQueueStateViewModel(callQueueModel) {
  return {
    queuedAtTimestamp: callQueueModel.queuedAfter,
    pendingCalls: callQueueModel.statistics.pending,
    failedCalls: callQueueModel.statistics.failed,
    completedCalls: callQueueModel.statistics.completed,
    totalCalls: callQueueModel.totalCalls,
    concurrencyLimit: callQueueModel.callConcurrency.concurrencyLimit ?? 3,
    concurrentCalls: callQueueModel.callConcurrency.concurrentCalls,
  };
}

export { getQueuedAtEpoch, getCallQueueStateViewModel };
